<div [formGroup]="form" class="flex-wrap">

  <mat-form-field>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NETZZUORDNUNG_ORTSNAME"
    [disabled]="!readonly && f.ortsname.disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>Ortsname</mat-label>
    <mat-select formControlName="ortsname"
      data-qa="ortsname"
      name="ortsname"
      (selectionChange)="handleOrtsnameChanged($event.source.value)">
      @for (ortsname of ortsnamenSelection; track ortsname) {
        <mat-option
          data-qa="ortsname-option"
          [value]="ortsname">
          {{ ortsname }}
        </mat-option>
      }
    </mat-select>
    @if (f.ortsname.hasError('required')) {
      <mat-error>
        Bitte wählen Sie einen gültigen Ortsnamen.
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NETZZUORDNUNG_STATIONSNAME"
    [disabled]="!readonly && f.stationsname.disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>Stationsname</mat-label>
    <mat-select formControlName="stationsname"
      data-qa="stationsname"
      name="stationsname"
      (selectionChange)="handleStationsnameChanged($event.source.value)">
      @for (stationsname of stationsNamenSelection; track stationsname) {
        <mat-option
          data-qa="stationsname-option"
          [value]="stationsname">
          {{ stationsname }}
        </mat-option>
      }
    </mat-select>
    @if (f.stationsname.hasError('required')) {
      <mat-error>
        Bitte wählen Sie einen gültigen Stationsname.
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field>
    <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_NETZZUORDNUNG_TRAFOFELD"
    [disabled]="!readonly && f.trafoFeldName.disabled"></redispatch-erzeugungsanlage-form-prefix>
    <mat-label>Trafo, Feld, Sammelschiene</mat-label>
    <mat-select formControlName="trafoFeldName"
      data-qa="trafoFeldName"
      name="trafoFeldName"
      (selectionChange)="handleTrafoFeldNameChanged($event.source.value)">
      @for (trafoFeldName of trafoFeldNamenSelection; track trafoFeldName) {
        <mat-option
          data-qa="trafoFeldName-option"
          [value]="trafoFeldName">
          {{ trafoFeldName }}
        </mat-option>
      }
    </mat-select>
    @if (f.trafoFeldName.hasError('required')) {
      <mat-error>
        Bitte wählen Sie eine gültige Trafo, Feld oder Sammelschiene.
      </mat-error>
    }
  </mat-form-field>

  @if (recentNetzzuordnung?.deactivated && !selectedNetzzuordnung) {
    <mat-error>
      Die vorherige Netzzuordnung ({{ assembleDescription(recentNetzzuordnung) }}) wurde vom Leitsystem deaktiviert.
      Bitte wählen Sie eine neue aus.
    </mat-error>
  }
</div>
